import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getPurchaseOrderStatus = async () => {
  const response = await axiosInstance.get(`${API_URL}/purchase-order-status`);
  return response.data;
};

export const getPurchaseOrderStatusById = async (id) => {
  const response = await axiosInstance.get(`${API_URL}/purchase-order-status/${id}`);
  return response.data;
};

export const createPurchaseOrderStatus = async (data) => {
  const response = await axiosInstance.post(`${API_URL}/purchase-order-status`, data);
  return response.data;
};

export const updatePurchaseOrderStatus = async (id, data) => {
  const response = await axiosInstance.put(`${API_URL}/purchase-order-status/${id}`, data);
  return response.data;
};

export const deletePurchaseOrderStatus = async (id) => {
  const response = await axiosInstance.delete(`${API_URL}/purchase-order-status/${id}`);
  return response.data;
};
